import { MutationTree } from 'vuex';
import { ProxySettingsState } from './types';

export const mutations: MutationTree<ProxySettingsState> = {
    pushProxySettings:(state, data) => {
        state.proxySettings = state.proxySettings.concat(data)
    },
    setProxySettings:(state, data) => {
        state.proxySettings = data
    },
    setProxySettingItem:(state, data) => {
        state.proxySettingItem = data
    },
};
